
import { IIsiDtoPlAttPreviewRequest, IIsiDtoPlAttPreviewResponse, IsiDtoPlAttPreviewRequest, IsiDtoPlAttPreviewResponse, IsiDtoPlAttPreviewResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlAttPreview";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";

import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlAttPreview extends IsiPresentationLogic {

    constructor() {
        super("IsiPlAttPreviewHandler");
    }


    /*-----------------------------------------------------------
    Renvoie le résultat de la méthode GetDroitAjoutPJActionOnPost du handler
    ----------------------------------------------------------*/
    GetDroitAjoutPJ(): Promise<IIsiUIFlowResult> {
        const dto: IIsiDtoPlAttPreviewRequest = new IsiDtoPlAttPreviewRequest;
        return new Promise<IIsiUIFlowResult>((resolve, reject) => {
            this._callAjax(dto, "GetDroitAjoutPJ").then((getAttPreview) => {
                resolve({
                    result: getAttPreview.getRightAddResult.attPreviewBoolResult,
                    continue: true
                })
            })
                .catch((o: IsiDtoPlAttPreviewRequest) => {
                    uiCore.showErrorMessage(o.response.error, false);
                    reject(o);
                });
        });
    }


    /*-----------------------------------------------------------
    Renvoie le résultat de la méthode GetDroitSupprPJActionOnPost du handler
    ----------------------------------------------------------*/
    GetDroitSupprPJ(suppressedDocole : number, memoCode : number): Promise<IIsiUIFlowResult> {
        const dto: IIsiDtoPlAttPreviewRequest = new IsiDtoPlAttPreviewRequest;

        dto.codeDocole = suppressedDocole;
        dto.codeMemo = memoCode;

        return new Promise<IIsiUIFlowResult>((resolve, reject) => {
            this._callAjax(dto, "GetDroitSupprPJ").then((getAttPreview) => {
                resolve({
                    result: getAttPreview.getRightDeleteResult.attPreviewResult === "OK",
                    continue: true
                });
            })
                .catch((o: IsiDtoPlAttPreviewRequest) => {
                    uiCore.showErrorMessage(o.response.error, false);
                    reject(o);
                });
        });
    }


    /*-----------------------------------------------------------
   Renvoie la response construite par _getResponseByTreatment 
   ----------------------------------------------------------*/
    private _callAjax(dto: IIsiDtoPlAttPreviewRequest, ajaxTreatment: string): Promise<IIsiDtoPlAttPreviewResponse> {
        return new Promise<IIsiDtoPlAttPreviewResponse>((resolve, reject) => {

            let responseByTreatment = this._getResponseByTreatment(ajaxTreatment);

            let dtoPretStrategy = IsiDtoPlAttPreviewRequest.fromJS({
                codeDocole: dto.codeDocole,
                codeMemo: dto.codeMemo,
                response: responseByTreatment
            });

            this.ajax(ajaxTreatment, dtoPretStrategy, true).then(
                (request: IsiDtoPlAttPreviewRequest) => {
                    resolve(request.response);
                }
            ).catch((data: IsiDtoPlAttPreviewResponse) => {
                reject(data);
            });
        });
    }

    /*-----------------------------------------------------------
    Renvoie la response selon le Traitement Ajax
    ----------------------------------------------------------*/
    private _getResponseByTreatment(ajaxTreatment: string) {
        switch (ajaxTreatment) {
            case "GetDroitAjoutPJ":
                return IsiDtoPlAttPreviewResponse.fromJS({
                    getRightAddResult: IsiDtoPlAttPreviewResult.fromJS({})
                })
            case "GetDroitSupprPJ":
                return IsiDtoPlAttPreviewResponse.fromJS({
                    getRightDeleteResult: IsiDtoPlAttPreviewResult.fromJS({})
                })
        }
    }
}